import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  max: number;
  label?: string;
  showPercentage?: boolean;
}
export function ProgressBar({
  current,
  max,
  label,
  showPercentage = true
}: ProgressBarProps) {
  const percentage = Math.min(current / max * 100, 100);
  return <div className="space-y-2" data-id="element-456">
      {label && <div className="flex justify-between items-center text-sm font-quicksand" data-id="element-457">
          <span className="text-gray-600 dark:text-gray-400" data-id="element-458">{label}</span>
          {showPercentage && <span className="font-bold text-game-purple" data-id="element-459">
              {current}/{max}
            </span>}
        </div>}
      <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden border border-gray-300 dark:border-gray-600" data-id="element-460">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="h-full bg-gradient-to-r from-game-purple to-game-teal rounded-full" data-id="element-461" />
      </div>
    </div>;
}